'use strict'

const { combineSubscribers } = require('redux-serial-effects')

const records = require('../records/subscriber')

module.exports = combineSubscribers({ records })



// WEBPACK FOOTER //
// ./dataset-controller/rootSubscriber.js